import React from 'react';
import PropTypes from 'prop-types';

const DoubleNumericalComponent = props =>
  <div className="content-item">
    <p className="font-700 mb-10">
      Summary Table
    </p>

    <table className="main-table" id="summary-table">
      <colgroup>
        <col className="bg-grey-150" />
      </colgroup>

      <thead>
        <tr>
          <th>Variables</th>

          <th className="text-right">Number of Observations</th>
          <th className="text-right">Standard Deviation</th>
          <th className="text-right">Mean</th>
          <th className="text-right">Correlation</th>
          <th className="text-right">Slope</th>
          <th className="text-right">Intercept</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td className="font-13 font-700">
            {props.firstParameterProps.name}
          </td>

          <td
            rowSpan="2"
            className="text-right"
            id="number-of-observations"
          >
            {props.numberOfObservations}
          </td>

          <td className="text-right" id={`${props.firstParameterProps.name}-stdev`}>
            {props.firstParameterProps.stdev}
          </td>

          <td className="text-right" id={`${props.firstParameterProps.name}-mean`}>
            {props.firstParameterProps.mean}
          </td>

          <td className="text-right" rowSpan="2" id="correlation">
            {props.correlationCoefficient}
          </td>

          <td className="text-right" rowSpan="2" id="slope">
            {props.linearRegressionProps.slope}
          </td>

          <td className="text-right" rowSpan="2" id="intercept">
            {props.linearRegressionProps.intercept}
          </td>
        </tr>

        <tr>
          <td className="font-13 font-700">
            {props.secondParameterProps.name}
          </td>

          <td className="text-right" id={`${props.secondParameterProps.name}-stdev`}>
            {props.secondParameterProps.stdev}
          </td>

          <td className="text-right" id={`${props.secondParameterProps.name}-mean`}>
            {props.secondParameterProps.mean}
          </td>
        </tr>
      </tbody>
    </table>
  </div>;

DoubleNumericalComponent.propTypes = {
  correlationCoefficient: PropTypes.number.isRequired,

  linearRegressionProps: PropTypes.shape({
    slope: PropTypes.number.isRequired,
    intercept: PropTypes.number.isRequired
  }).isRequired,

  numberOfObservations: PropTypes.number.isRequired,

  firstParameterProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    mean: PropTypes.number.isRequired,
    stdev: PropTypes.number.isRequired
  }).isRequired,

  secondParameterProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    mean: PropTypes.number.isRequired,
    stdev: PropTypes.number.isRequired
  }).isRequired
};

export default DoubleNumericalComponent;
